import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { FormSwitch } from "@redotech/redo-web/switch";
import { input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const showSuppliesStorefrontInput = input<boolean>();

export const showSuppliesStorefrontDefault = false;

export const SuppliesSettingsCard = memo(function SuppliesSettingsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  return (
    <Card title="Supplies Settings" w="full">
      <Flex dir="column" gap="md">
        <FormSwitch
          input={input.inputs.showSuppliesStorefront}
          label="Show Supplies Storefront"
        />
      </Flex>
    </Card>
  );
});
